import psHttp, { RequestChannel } from '@patsnap/common-ps-http';
import { coreSearchApiUrlPrefix, workspaceApiUrlPrefix } from '../../config/constants';


export function getMoreSRPAbstApi(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/patent/detail`,
        method: 'POST',
        data: params,
        transformCode: true
    }).then(res =>{
        return res.data || {};
    });
}


const fetchFunctionBarChannel = new RequestChannel();
const fetchPatentChannel = new RequestChannel();
export function getFunctionListApi (data) {
    return fetchFunctionBarChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/srp/function-list`,
        method: 'POST',
        data
    });
}

export function getPatentApi (data) {
    return fetchPatentChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/srp/patents`,
        method: 'POST',
        data
    });
}

// 获取专利在Workspace的数据
export function getPatentsExistDetailApi({
    patent_ids
}) {
    return psHttp({
        url: `${workspaceApiUrlPrefix}/patents/exist/detail`,
        method: 'POST',
        data: {
            patent_ids
        }
    }).then(res => {
        return res.data.data;
    });
}

export function getSRPAbstApi(params) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/abst`,
        method: 'GET',
        params
    }).then(({
        data
    }) => {
        data.data.PATENT_ID = params.patentId;
        return data;
    });
}

export function getSRPPdfApi({
    patentId,
    lang
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/pdf?patentId=${patentId}&ttlLang=${lang}`,
        method: 'GET',
        transformCode: true
    });
}

export function getTargetSequencesApi({
    patent_ids,
    bio_uk
}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/sequence`,
        method: 'POST',
        data: {
            patent_ids,
            bio_uk
        }
    }).then(res => {
        return res.data;
    });
}

export function getFilterSortApi() {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/filtersort`,
        method: 'GET',
        transformCode: true
    });
}

export function saveFilterSortApi(data = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/filtersort`,
        method: 'PUT',
        data,
        transformCode: true
    }).then(({ data }) => {
        return data || {};
    });
}

export function saveSettingApi(data = {}) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/setting`,
        method: 'PUT',
        data,
        transformCode: true
    });
}

/**
 * 获取同族命中专利列表
 * @param patentId
 * @param hitFamilyId
 * @returns {Promise<unknown>}
 */
export function getHitFamilyList (data/* { patent_id: string, hit_family_id: string } */) {
    return psHttp({
        url: `${coreSearchApiUrlPrefix}/srp/hit-family-list`,
        method: 'POST',
        data,
        transformCode: true,
    });
}

/**
 * 获取同族未命中专利列表
 * @param params { patent_id: string, search_mode?: 'family' | 'publication' | 'unset' } 
 * @returns {Promise<unknown>}
 */
export function getFamilyList (params) {
    return fetchPatentChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/srp/family-list`,
        method: 'GET',
        params,
        transformCode: true,
    });
}

/**
 * 根据专利id获取专利分析数据
 * @param data
 * @returns {Promise<unknown>}
 */
export function getFamilyAnalysis (data) {
    return fetchPatentChannel.requestAsPromise({
        url: `${coreSearchApiUrlPrefix}/srp/family-analysis`,
        method: 'POST',
        data,
        transformCode: true
    });
}
